import { Link, useNavigate } from 'react-router-dom'
import Header from '../../components/Header'
import Page from '../../components/Page'
import VitaArchivioForm from '../../components/VitaArchivioForm'
import { useCreateVitaArchivio } from '../../hooks/vite-archivio'

export default function ExtraCreate() {
  const createVitaArchivio = useCreateVitaArchivio()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/vite-archivio">Vite d'archivio</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Aggiungi
            </li>
          </ol>
        </nav>
      </Header>
      <div className="py-3 overflow-y-auto flex-1">
        <VitaArchivioForm
          refetch={() => {}}
          save={async (vita) => {
            const savedVita = await createVitaArchivio.mutateAsync(vita)
            navigate(`/vite-archivio/${savedVita.id}`)
          }}
        />
      </div>
    </Page>
  )
}
